var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"body-1"},[(_vm.timeIsOver)?[_vm._v(" Время истекло ")]:(_vm.timeIsLimited)?[_vm._v(" Прошло "+_vm._s(_vm.timeElapsed)+" из "+_vm._s(_vm.timeTotal)+" ")]:[_vm._v(" Прошло "+_vm._s(_vm.timeElapsed)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }